import { Skeleton } from "@/components/ui/skeleton";

import { formatarReais as reais } from "./formatarReais";

function Divisor() {
  return <span className="w-px h-3 bg-border shrink-0" />;
}

/**
 * Pedidos, faturamento, ticket médio e tempo médio de hoje (BRT), vindos de
 * /pedidos/stats. O ticket é faturamento ÷ pedidos do dia — os dois já sem
 * cancelados e agendados, então a conta fecha com os números ao lado.
 */
export default function ResumoDoDia({ pedidos, faturamento, tempoMedio, carregando = false }) {
  const ticket = pedidos > 0 ? faturamento / pedidos : 0;
  if (carregando) {
    return (
      <div className="bg-card/95 backdrop-blur-sm border border-border/60 rounded-xl shadow-lg px-3 py-2 flex items-center gap-3"
        data-e2e="resumo-dia-carregando" aria-busy="true" aria-label="Carregando">
        <span className="w-1.5 h-1.5 rounded-full bg-muted-foreground/40 shrink-0" />
        <Skeleton className="h-3.5 w-14" />
        <Divisor />
        <Skeleton className="h-3.5 w-16" />
        <Divisor />
        <Skeleton className="h-3.5 w-20" />
        <Divisor />
        <Skeleton className="h-3.5 w-10" />
      </div>
    );
  }
  return (
    <div className="bg-card/95 backdrop-blur-sm border border-border/60 rounded-xl shadow-lg px-3 py-2 flex items-center gap-3 text-xs whitespace-nowrap">
      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse shrink-0" />
      <div className="flex items-center gap-1" title="Pedidos de hoje, sem cancelados">
        <span className="font-bold text-foreground tabular-nums">{pedidos}</span>
        <span className="text-[10px] text-muted-foreground">{pedidos === 1 ? "pedido" : "pedidos"}</span>
      </div>
      <Divisor />
      <span className="font-bold text-emerald-600 dark:text-emerald-400 tabular-nums" title="Faturamento de hoje">
        {reais(faturamento)}
      </span>
      <Divisor />
      <div className="flex items-center gap-1" title="Ticket médio de hoje (faturamento ÷ pedidos)">
        <span className="text-[10px] text-muted-foreground">ticket</span>
        <span className="font-bold text-foreground tabular-nums">{reais(ticket)}</span>
      </div>
      <Divisor />
      <div className="flex items-center gap-1" title="Tempo médio do pedido hoje, da entrada à conclusão">
        <span className={`font-bold tabular-nums ${tempoMedio > 30 ? "text-red-500" : "text-sky-500"}`}>⏱ {tempoMedio}</span>
        <span className="text-[10px] text-muted-foreground">min</span>
      </div>
    </div>
  );
}
